import React from 'react';
import styles from './CoreHeading.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { Heading } from '@/components';
import formatStyles from '@/helpers/formatStyles';

let cx = className.bind(styles);

export default function CoreHeading(props) {
	const { attributes } = props;
  const style = formatStyles(attributes.style);
  const className = attributes.className?.split(' ') || [];

	return (
		attributes.content && (
			<Heading id={attributes.anchor} className={cx(['heading', ...className, attributes.textColor && `text-color-${attributes.textColor}`, attributes.backgroundColor && `bg-${attributes.backgroundColor}`, attributes.fontSize && `is-font-size-${attributes.fontSize}`])} level={attributes.level && `h${attributes.level}`} textAlign={attributes.textAlign} style={style}>
        {attributes.content}
			</Heading>
		)
	);
}

CoreHeading.fragments = {
	key: `CoreHeadingFragment`,
	entry: gql`
		fragment CoreHeadingFragment on CoreHeading {
			attributes {
        anchor
        className
        content
        level
        textAlign
        style
        fontSize
        textColor
        backgroundColor
      }
		}
	`,
};

CoreHeading.config = {
	name: 'CoreHeading',
};
CoreHeading.displayName = 'CoreHeading';